import { render, staticRenderFns } from "./MenuMovil.vue?vue&type=template&id=447ef60c&scoped=true"
import script from "./MenuMovil.vue?vue&type=script&lang=js"
export * from "./MenuMovil.vue?vue&type=script&lang=js"
import style0 from "./MenuMovil.vue?vue&type=style&index=0&id=447ef60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ef60c",
  null
  
)

export default component.exports